import FieldSet from '../../FieldSet';
import terminology from 'javascripts/terminology';

import { ReleaseIcon } from './ReleaseIcon';
import { ReleaseName } from './ReleaseName';

export class ReleaseFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [ReleaseIcon, ReleaseName];
  }

  get title() {
    return terminology('Release');
  }
}
